import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[exCompHost]',
    standalone: false
})
export class ExComponentHost {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
